"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable
exports.logger = {
    debug: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return console.debug.apply(console, [new Date()].concat(params));
    },
    error: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return console.error.apply(console, [new Date()].concat(params));
    },
    info: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return console.info.apply(console, [new Date()].concat(params));
    },
    warn: function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return console.warn.apply(console, [new Date()].concat(params));
    },
};
// tslint:enable
